import { useState } from "react";
import { useStore } from "../data/store";
import { Btn, Stat } from "../ui/bits";
import { Soheil } from "../ui/Soheil";
import { formatJalali, toFa } from "@soheil/core";
import { productDay } from "@soheil/core";

const MOODS: Array<[1 | 2 | 3 | 4 | 5, string, string]> = [
  [1, "😔", "سخت"], [2, "🙁", "بی‌رمق"], [3, "😐", "معمولی"], [4, "🙂", "خوب"], [5, "😄", "عالی"],
];

/** مرور شب — باید حدود ۳۰ ثانیه طول بکشد، نه بیشتر. */
export function Night() {
  const { state, dispatch, today } = useStore();
  const saved = state.reviews.find((r) => r.localDate === today);
  const [mood, setMood] = useState<1 | 2 | 3 | 4 | 5>(saved?.mood ?? 3);
  const [win, setWin] = useState(saved?.bestWin ?? "");
  const [tomorrow, setTomorrow] = useState(saved?.tomorrowTop ?? "");
  const [done, setDone] = useState(!!saved);

  const stars = state.stars.filter((s) => s.localDate === today).reduce((a, b) => a + b.delta, 0);
  const habitsDone = state.habitLogs.filter((l) => l.localDate === today).length;
  const habitsAll = state.habits.filter((h) => !h.archived && !h.deletedAt).length;
  const water = state.health.find((h) => h.kind === "water" && h.localDate === today)?.value ?? 0;
  const studied = state.sessions
    .filter((s) => s.completedAt && productDay(new Date(s.completedAt)) === today)
    .reduce((a, s) => a + Math.round(s.durationSec / 60), 0);

  return (
    <div className="screen">
      <header className="daybar">
        <div><h1>مرور قبل خواب</h1><span>{formatJalali(today, { withWeekday: true })}</span></div>
      </header>

      <div className="nightcard">
        <div className="nightcard-bear" data-pose="sleepy"><Soheil pose="sleepy" /></div>
        <div className="nightcard-stats">
          <Stat value={`${toFa(habitsDone)} از ${toFa(habitsAll)}`} label="عادت" tone="gold" />
          <Stat value={toFa(studied)} label="دقیقه مطالعه" tone="sage" />
          <Stat value={`${toFa(water)} از ${toFa(state.settings.waterGoal)}`} label="لیوان آب" tone="lilac" />
          <Stat value={toFa(stars)} label="ستارهٔ امروز" tone="gold" />
        </div>
      </div>

      {done ? (
        <div className="nightdone">
          <b>مرور امروز ثبت شد 🤍</b>
          <p>سهیل هم می‌رود بخوابد. فردا می‌بینیمت.</p>
          <Btn variant="quiet" onClick={() => setDone(false)}>ویرایش</Btn>
        </div>
      ) : (
        <form
          className="night-form"
          onSubmit={(e) => {
            e.preventDefault();
            dispatch({ type: "saveReview", day: today, mood, bestWin: win.trim() || undefined, tomorrowTop: tomorrow.trim() || undefined });
            setDone(true);
          }}
        >
          <label className="lbl">امروز چطور بود؟</label>
          <div className="moods">
            {MOODS.map(([v, e, t]) => (
              <button key={v} type="button" data-on={mood === v ? "1" : "0"} onClick={() => setMood(v)}>
                <span>{e}</span><em>{t}</em>
              </button>
            ))}
          </div>

          <label className="lbl">بهترین برد امروز</label>
          <input className="input" value={win} onChange={(e) => setWin(e.target.value)} placeholder="حتی یک چیز کوچک" />

          <label className="lbl">مهم‌ترین کار فردا</label>
          <input className="input" value={tomorrow} onChange={(e) => setTomorrow(e.target.value)} placeholder="فقط یکی" />

          <Btn type="submit" full>ثبت مرور</Btn>
        </form>
      )}
    </div>
  );
}
